import React from 'react';
import './Popups.css';

const ConfirmPopup = ({ show, title, message, onConfirm, onCancel }) => {
  if (!show) return null;

  return (
    <div className="popup-overlay">
      <div className="popup-card">
        <h3 className="popup-title">{title}</h3>
        <p className="popup-message">{message}</p>

        <div className="popup-buttons">
          <button className="popup-btn cancel" onClick={onCancel}>
            Cancel
          </button>
          <button className="popup-btn ok" onClick={onConfirm}>
            Yes
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmPopup;

